import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, SimpleChange } from "@angular/core";
import { BaseMapService } from "./baseMap.service";
import { LatLngBoundsLiteral, AgmMap } from "@agm/core";
import { Router } from "@angular/router";

@Component({
  selector: "GMapComponent",
  templateUrl: "./basemap.component.html",
  styleUrls: ["./basemap.component.scss"]
})

export class BasemapComponent implements OnInit, OnChanges {
  @Input() locationData: any[];
  @Input() disableZoom: any;
  @Input() disableStreetView: any;
  @Input() fitBounds: boolean = true;
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() zoomLevel: number = 12;
  @Input() className: string = "";
  public disableZoomControl: boolean = true;
  public disableStreetViewControl: boolean = false;
  public mapBounds: LatLngBoundsLiteral;
  public locationIcon= { url: "./assets/core/img/map-location.png", scaledSize: { width: 30, height: 48 } };
  public currentLocationIcon= { url: "./assets/core/img/map-current-location.png", scaledSize: { width: 30, height: 48 } };

  private infoWindowOpened = null;
  @ViewChild(AgmMap) public agmMap: AgmMap;
  constructor(private baseMapService: BaseMapService
    , private _router: Router) {

  }

  ngOnInit() {
    const me = this;
    me.disableZoomControl = true;

    if (this.disableZoom) {
      this.disableZoomControl = this.disableZoom;
    }
    if (this.disableStreetView) {
      this.disableStreetViewControl = this.disableStreetView;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const name: SimpleChange = changes.name;
  }

  public navigateToLocationDetail(locationId: number | string): void {
    const me = this;
    this._router.navigate(["/locationdetail", locationId]);
  }

  // Close infowindow by clicking on other infowindow
  public markerClick(infoWindow, index: number): void {
    const me = this;
    if (me.infoWindowOpened === infoWindow) {
      return;
    }
    if (me.infoWindowOpened !== null) {
      me.infoWindowOpened.close();
    }
    me.infoWindowOpened = infoWindow;
  }

  public mapClick(event) {
    const me = this;
    if (me.infoWindowOpened !== null) {
      me.infoWindowOpened.close();
    }
  }
}
